import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinnerView from '../../../../Common/Components/LoadingSpinnerView.jsx';

const ImportInProgressView = () => (
    <div data-component="ImportInProgressView">
        <div className="segment">
            <h2>Importing, please wait...</h2>
            <div className="inline">
                <LoadingSpinnerView text="Importing..." inline={ true } />
            </div>
        </div>
    </div>
);

ImportInProgressView.propTypes = { };

export default ImportInProgressView;
